import { Star } from 'lucide-react';

export default function ReviewsSlider({ items = [] }) {
  const looped = [...items, ...items];

  if (!items.length) {
    return null;
  }

  return (
    <div className="overflow-hidden">
      <div className="animate-infinite-slide flex gap-4 will-change-transform">
        {looped.map((item, index) => (
          <article
            key={`${item.id || item.navn}-${index}`}
            className="w-[88vw] shrink-0 border border-brand-gray-200 bg-white p-6 sm:w-[52vw] lg:w-[31vw]"
          >
            <div className="flex items-center gap-1 text-brand-orange">
              {Array.from({ length: Math.max(1, Number(item.karakter) || 5) }).map((_, starIndex) => (
                <Star key={starIndex} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <p className="mt-5 text-sm leading-7 text-brand-gray-700">
              “{item.tekst}”
            </p>
            <div className="mt-6 border-t border-brand-gray-100 pt-4">
              <p className="font-display text-lg font-bold text-brand-black">
                {item.navn}
              </p>
              {item.projekt ? (
                <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-brand-gray-500">
                  {item.projekt}
                </p>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
